import React, {Component} from 'react';

import SEO from '../components/seo';
import Breadcrumb from '../components/breadcrumb';
import Layout from '../layouts';

class aboutUs extends Component {

    render (){
        const data = this.props.pageContext
        
        return (
            <Layout>
                <SEO title={data.title}/>
                <Breadcrumb title={data.title}/>
                {/*about section*/}
                <section className="page section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 mb-5">
                                <h1 className="text-center">{data.title}</h1>
                            </div>
                            <div className="col-sm-12" dangerouslySetInnerHTML={{__html: data.body}}></div>
                        </div>
                    </div>
                </section>
            </Layout>
        )
    }
}

export default aboutUs